export default __webpack_public_path__ + "static/media/CO2_history.c31febb6.jpg";